import React, {Component, ReactElement, ReactNode} from 'react'
import {
    ADMINISTORATOR_MODE,
    DISP_TYPE_ALL_MODE,
    DISP_TYPE_ARTICLE_SELECT_MODE,
    LIFE_CONVENIENT_BOOK_CATEGORY,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    TARGET_ATT,
    YES_OR_NOT,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links'
import {formatDateZeroPadding} from '../../../formatters/formatDate'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material'
import NatLifeNoteRepo from './repository/NatLifeNoteRepo'
import {LifeNoteNotDeliveryCondominiumList, NatGetLifeNote} from './repository/NatGetLifeNote'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {NatDeleteLifeNote} from './repository/NatDeleteLifeNote'
import styled from 'styled-components'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {StyledDiv, StyledImg} from '../../../styledComponents/StyledTypeDefinitions'
import {
    BillingStatus,
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
} from '../condominium/repository/NatGetCondominiumList'
import {SortOrder} from '../../../components/shared/SortOrder'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const KEY_SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface LocationState {
    initialMessage: HeadingAreaMessageParams
}

interface Props {
    lifeNoteId: string
    lifeNoteRepo: NatLifeNoteRepo
    condominiumRepo: NatCondominiumRepo
    eventEmitter: EventEmitterExAdmin
    location: Location<LocationState>
}

interface States {
    condominiumGroupName: string,
    lifeNoteNotDeliveryCondominiumList: LifeNoteNotDeliveryCondominiumList[] | null,
    deliveryTargetPrefectureCd: string,
    deliveryTargetAddress2: string,
    lifeNoteDeliveryTargetCondominiumList: CondominiumInfo[],
    displayCategory: string,
    category: string,
    title: string,
    description: string
    publishStartDate: string
    publishEndDate: string
    sortOrder: number
    url: string
    targetAttr: string
    path: string
    version: number
    isLoadCompleted: boolean
    deleteImpossibleFlg: boolean
}


class NatAdminLifeNoteDetailsPage extends Component<Props & AdminPagePropsSet, States> {
    mode: Nullable<string>
    condominiumCd: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.mode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)
        this.condominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)

        this.state = {
            condominiumGroupName: '',
            lifeNoteNotDeliveryCondominiumList: [],
            lifeNoteDeliveryTargetCondominiumList: [],
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            displayCategory: '',
            category: '',
            title: '',
            description: '',
            publishStartDate: '',
            publishEndDate: '',
            sortOrder: 0,
            url: '',
            targetAttr: '',
            path: '',
            version: 0,
            isLoadCompleted: false,
            deleteImpossibleFlg: false,
        }
        this.backLifeNoteListLinkClick = this.backLifeNoteListLinkClick.bind(this)
        this.editScheduleLinkClick = this.editScheduleLinkClick.bind(this)
        this.deleteLifeNote = this.deleteLifeNote.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleDeleteOkClick = this.handleDeleteOkClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 生活便利帳取得
            const lifeNote: Nullable<NatGetLifeNote> = await this.props.asyncCallFunction(
                this.props.lifeNoteRepo.getLifeNote.bind(this.props.lifeNoteRepo, this.props.lifeNoteId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (lifeNote && lifeNote.details) {
                let displayCategory: string = ''
                if (!lifeNote.details.condominiumName) {
                    const displayCategoryMaster =
                        DISP_TYPE_ALL_MODE.codeToEnumConstants(lifeNote.details.displayCategory)
                    if (displayCategoryMaster) {
                        displayCategory = displayCategoryMaster.label
                    }
                } else {
                    const displayCategoryMaster =
                        DISP_TYPE_ARTICLE_SELECT_MODE.codeToEnumConstants(lifeNote.details.displayCategory)
                    if (displayCategoryMaster) {
                        displayCategory = displayCategoryMaster.label
                    }
                }
                let category: string = ''
                const categoryMaster =
                    LIFE_CONVENIENT_BOOK_CATEGORY.codeToEnumConstants(lifeNote.details.categoryId)
                if (categoryMaster) {
                    category = categoryMaster.label
                }

                let targetAttr: string = ''
                const targetAttrMaster =
                    TARGET_ATT.codeToEnumConstants(lifeNote.details.targetAttr)
                if (targetAttrMaster) {
                    targetAttr = targetAttrMaster.label
                }

                // 削除不可能フラグ
                const deleteImpossibleFlg: boolean = lifeNote.details.controlFlag === YES_OR_NOT.NO.value

                ReactDOM.flushSync(() => {
                    if (lifeNote && lifeNote.details) {
                        this.setState({
                            condominiumGroupName: lifeNote.details.condominiumGroupName,
                            deliveryTargetPrefectureCd: lifeNote.details.deliveryTargetPrefectureCd ?
                                lifeNote.details.deliveryTargetPrefectureCd : '',
                            deliveryTargetAddress2: lifeNote.details.deliveryTargetAddress2 ?
                                lifeNote.details.deliveryTargetAddress2 : '',
                            lifeNoteNotDeliveryCondominiumList: lifeNote.details.lifeNoteNotDeliveryCondominium,
                            displayCategory: displayCategory,
                            category: category,
                            title: lifeNote.details.title,
                            description: lifeNote.details.description,
                            publishStartDate: lifeNote.details.publishStartDate,
                            publishEndDate: lifeNote.details.publishEndDate,
                            sortOrder: lifeNote.details.sortOrder,
                            url: lifeNote.details.url,
                            targetAttr: targetAttr,
                            path: lifeNote.details.path,
                            version: lifeNote.details.version,
                            isLoadCompleted: true,
                            deleteImpossibleFlg: deleteImpossibleFlg,
                        })
                    }
                })
                // 配信対象物件一覧の設定
                await this.getSelectedDeliveryTargetCondominiumInfo(
                    lifeNote.details.condominiumGroupId,
                    this.state.deliveryTargetPrefectureCd,
                    this.state.deliveryTargetAddress2,
                )
            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 配信対象物件一覧の取得
    async getSelectedDeliveryTargetCondominiumInfo(
        condominiumGroupId: Nullable<number>,
        deliveryTargetPrefectureCd: Nullable<string>,
        deliveryTargetAddress2: Nullable<string>,
    ): Promise<void> {
        if (deliveryTargetPrefectureCd !== '' || deliveryTargetAddress2 !== '') {
            const billingStatus: BillingStatus = {
                billingDeadline: null,
                confirmStatus: null,
                targetYearMonth: null,
                electedTargetYearMonth: null,
            }
            const searchCondition: SearchCondition = {
                condominiumCd: null,
                condominiumName: null,
                condominiumGroupId: condominiumGroupId,
                prefectureCd: deliveryTargetPrefectureCd,
                address2: deliveryTargetAddress2,
                detailSearchCondition: null,
                billingStatus: billingStatus,
                unreleaseCondominiumExclusionFlg: null,
            }
            const searchConditionPageInfo: SearchConditionPageInfo = {
                pageNum: 0,
                page: 0,
            }
            const searchConditionSortInfo: SortOrder[] = [new SortOrder('condominiumCd', 'asc')]

            this.setState({
                lifeNoteDeliveryTargetCondominiumList:
                    await this.searchCondominiums(
                        searchCondition,
                        searchConditionPageInfo,
                        searchConditionSortInfo),
            })
        }
    }

    // 物件一覧検索結果の取得
    async searchCondominiums(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<CondominiumInfo[]> {
        const searchParams: string[] = []

        if (searchConditionSortInfo) {

            searchConditionSortInfo.forEach((sortInfo) => {
                const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                searchParams.push(`sortInfo=${value}`)
            })
        }

        // 物件一覧取得
        const getCondominiumResponse: Nullable<NatGetCondominiumList> =
            await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominiumList.bind(
                    this.props.condominiumRepo,
                    {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

        if (getCondominiumResponse) {
            if (getCondominiumResponse.details) {
                return getCondominiumResponse.details.condominiumInfo
            }
        }
        return []
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    backLifeNoteListLinkClick(): void {
        this.props.navigate(`/admin/lifeNoteList`)
    }

    editScheduleLinkClick(): void {
        this.props.navigate(`/admin/lifeNoteEdit/${this.props.lifeNoteId}`)
    }

    // 削除ボタン押下
    async deleteLifeNote(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0011.errorLevel,
                message: Messages.IOPCC0011.toString(this.state.title),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleDeleteOkClick,
                    },
                ],
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleDeleteOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const deleteLifeNoteResponse: Nullable<NatDeleteLifeNote> = await this.props.asyncCallFunction(
                this.props.lifeNoteRepo.deleteLifeNote.bind(
                    this.props.lifeNoteRepo, this.props.lifeNoteId),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (deleteLifeNoteResponse &&
                deleteLifeNoteResponse.requestError === null) {
                this.props.navigate(`/admin/lifeNoteList`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0006.toString('生活便利帳', this.state.title),
                            },
                        },
                    },
                )
            } else {
                return
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    getFormatDateZeroPaddingAllowNull(publishEndDate: string): string {
        if (publishEndDate !== null) {
            return formatDateZeroPadding(publishEndDate)
        } else {
            return publishEndDate
        }
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    renderScheduleTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>生活便利帳情報</StyledTableCaption>
                    <TableBody>
                        {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                            <>
                                <TableRow>
                                    <TableRowName>物件グループ</TableRowName>
                                    <TableCell colSpan={4}>
                                        {this.state.condominiumGroupName}
                                    </TableCell>
                                </TableRow>
                                {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== '' ?
                                    <>
                                        <TableRow>
                                            <TableRowName>
                                                配信対象
                                            </TableRowName>
                                            <TableCell colSpan={4}>
                                                {`指定地域: ${this.getPrefectureName(this.state.deliveryTargetPrefectureCd)}${this.state.deliveryTargetAddress2}`}
                                                {
                                                    <InnerMiniTable>
                                                        <InnerMiniTableBody>
                                                            {
                                                                this.state.lifeNoteDeliveryTargetCondominiumList.map(
                                                                    (condominiumInfo, index) => {
                                                                        return (
                                                                            <TableRow
                                                                                key={condominiumInfo.condominiumCd}>
                                                                                <InnerMiniTableCell>
                                                                                    {condominiumInfo.condominiumCd + ' ' +
                                                                                        condominiumInfo.condominiumName}
                                                                                </InnerMiniTableCell>
                                                                            </TableRow>
                                                                        )
                                                                    })
                                                            }
                                                        </InnerMiniTableBody>
                                                    </InnerMiniTable>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    </>
                                    : <></>
                                }
                                {this.state.lifeNoteNotDeliveryCondominiumList &&
                                    <>
                                        <TableRow>
                                            <TableRowName
                                                rowSpan={this.state.lifeNoteNotDeliveryCondominiumList.length + 1}>
                                                除外する物件
                                            </TableRowName>
                                        </TableRow>
                                        {this.state.lifeNoteNotDeliveryCondominiumList.map(
                                            (lifeNoteNotDeliveryCondominium) => (
                                                <TableRow>
                                                    <TableCell>
                                                        {lifeNoteNotDeliveryCondominium.condominiumCd}
                                                        {'　' + lifeNoteNotDeliveryCondominium.condominiumName}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </>
                                }
                            </>
                        }
                        <TableRow>
                            <TableRowName>カテゴリ</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.category}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>タイトル</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.title}
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableRowName>メモ</TableRowName>
                            <TableCellWordBreakAll colSpan={4}>
                                <ExplainText>{this.state.description}</ExplainText>
                            </TableCellWordBreakAll>
                        </TableRow>
                        <TableRow>
                            <TableRowName>掲載開始日</TableRowName>
                            <TableCell colSpan={4}>
                                {`${formatDateZeroPadding(this.state.publishStartDate)} `}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>掲載終了日</TableRowName>
                            <TableCell colSpan={4}>
                                {this.getFormatDateZeroPaddingAllowNull(this.state.publishEndDate)}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>並び順</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.sortOrder}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>リンク先URL</TableRowName>
                            <TableCellWordBreakAll colSpan={4}>
                                {this.state.url}
                            </TableCellWordBreakAll>
                        </TableRow>
                        <TableRow>
                            <TableRowName>ターゲット属性</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.targetAttr}
                            </TableCell>
                        </TableRow>
                        {this.state.displayCategory !== DISP_TYPE_ALL_MODE.AREA_INFO.label &&
                            this.state.displayCategory !== DISP_TYPE_ARTICLE_SELECT_MODE.NO_BANNER.label &&
                            <TableRow>
                                <TableRowName>画像</TableRowName>
                                {this.state.path &&
                                    <TableCell colSpan={4}>
                                        <TableCellImg>
                                            <CondominiumImg src={this.state.path + '?' + String(this.state.version)}/>
                                        </TableCellImg>
                                    </TableCell>
                                }
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageHeaderArea(): Nullable<ReactNode> {
        return (
            <>
                <PageFotterAreaRight>
                    <DeleteLink
                        onClick={this.deleteLifeNote}>
                        生活便利帳を削除する
                    </DeleteLink>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <AdminPrimaryButton
                        onClick={this.editScheduleLinkClick}>
                        編集する
                    </AdminPrimaryButton>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backLifeNoteListLinkClick}
                    >
                        生活便利帳検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                {!this.state.deleteImpossibleFlg &&
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_LIFE_NOTE_MANAGEMENT}>
                        <Box mb={'15px'}>
                            <PageFooterArea>
                                {this.renderPageHeaderArea()}
                            </PageFooterArea>
                        </Box>
                    </AuthorityChecker>
                }
                <PageMainArea>
                    {this.renderScheduleTable()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminLifeNoteDetailsPage)

const TableCellWordBreakAll = styled(TableCell)`
    &.MuiTableCell-root {
        word-break: break-all;
    }
`

const TableCellImg: StyledDiv = styled.div`
    width: 400px;
`

const CondominiumImg: StyledImg = styled.img`
    width: 100%;
    height: auto;
`

const ExplainText: StyledDiv = styled.div`
    white-space: pre-wrap;
`
